import startCase from 'lodash/startCase';

import { TprmRequirementDefinition } from '@evidentid/tprm-portal-lib/models/common';
import {
    ActionDetails,
    ActionMatchType,
    ActionType,
    ComplianceWithCategoryActionDetails,
    EntityNameMatchingActionDetails,
    NonExtractionResolutionActionDetails,
} from '@evidentid/tprm-portal-lib/models/entity-actions-review';

function extractFieldName(field: string): string {
    const tokens = field.split('.');
    return tokens[tokens.length - 1];
}

export function getEntityMatchFieldName(actionDetails: EntityNameMatchingActionDetails): string {
    switch (actionDetails.matchType) {
        case ActionMatchType.insured:
            return 'Entity Name';
        case ActionMatchType.relyingParty:
            return 'Relying Party';
        case ActionMatchType.custom:
            return extractFieldName(actionDetails.field);
        default:
            return '';
    }
}

function getEntityNameMatching(actionDetails: EntityNameMatchingActionDetails): string {
    const prefix = 'Entity Name Matching';
    const fieldNameLabel = startCase(getEntityMatchFieldName(actionDetails));
    const hyphen = fieldNameLabel ? ' - ' : '';
    return `${prefix}${hyphen}${fieldNameLabel}`;
}

function getNonExtractionCriterionResolution(
    actionDetails: NonExtractionResolutionActionDetails,
    requirementDefinitions: Record<string, TprmRequirementDefinition> = {},
): string {
    const req = requirementDefinitions[actionDetails.coverageType];
    const reqLabel = req?.defaultLabel || startCase(actionDetails.coverageType.toLowerCase());
    switch (actionDetails.field) {
        case 'exclusions':
            return 'Exclusion Review';
        case 'projectRequirements':
            return 'Project Requirement Review';
        case 'documentVerification':
            return `Valid Document Review - ${reqLabel}`;
        default:
            return `${startCase(actionDetails.field)} Review`;
    }
}

function getComplianceWithCategoryResolution(actionDetails: ComplianceWithCategoryActionDetails) {
    const fieldName = extractFieldName(actionDetails.field);
    const fieldNameLabel = startCase(fieldName);
    return `Form Number Matching - ${fieldNameLabel}`;
}

export function getActionRequired(
    actionDetails: ActionDetails,
    requirementDefinitions?: Record<string, TprmRequirementDefinition>,
): string {
    switch (actionDetails.$action) {
        case ActionType.endorsementFormNumberV1:
            return 'Endorsement Review';
        case ActionType.evaluatedEntityMappingV1:
            return 'Collateral mapping';
        case ActionType.contractExtraction:
            return 'Review auto-extracted criteria and fill in any missing blanks.';
        case ActionType.entityNameMatchingV1:
            return getEntityNameMatching(actionDetails);
        case ActionType.nonExtractionCriterionResolutionV1:
            return getNonExtractionCriterionResolution(actionDetails, requirementDefinitions);
        case ActionType.complianceWithCategoryResolution:
            return getComplianceWithCategoryResolution(actionDetails);
        case ActionType.aieManuscriptCategorization:
            return 'Endorsement Review - Additional Insured Endorsement';
        case ActionType.documentDataReview:
            return 'Document Data Review - Review AI-extracted fields and fill in any missing blanks.';
        default:
            return '';
    }
}
